import styled from 'styled-components';
import { Box, FormHelperText } from '@mui/material';

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const StyledFormHelperText = styled(FormHelperText)({
  color: '#d32f2f !important',
  marginTop: '8px !important',
});

export const Page = styled(Box)({
  width: '100%',
  maxWidth: '1600px',
  paddingBottom: '48px',
});

export const Header = styled(Box)({
  marginBottom: '26px',
});

export const FormSection = styled(Box)({
  padding: '26px 0',
  borderBottom: '1px solid #e1e5ea',
});

export const SectionHeader = styled(Box)({
  marginBottom: '20px',
});

export const LanguageGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '16px',

  '@media (max-width: 1050px)': {
    gridTemplateColumns: '1fr',
  },
});

export const LanguageColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
});

export const LanguageTitle = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
});

export const LanguageBadge = styled(Box)({
  padding: '3px 8px',
  color: '#397bc9',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.08em',
  background: '#edf5ff',
  borderRadius: '12px',
});

export const UploadBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '24px',
  minHeight: '104px',
  padding: '20px 22px',
  background: '#fafcff',
  border: '1px dashed #9cbde5',
  borderRadius: '8px',

  '@media (max-width: 700px)': {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
});

export const ImagesRow = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
  marginBottom: '20px',
});

export const SettingsBox = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '24px',
  padding: '22px',
  border: '1px solid #dfe3e8',
  borderRadius: '6px',

  '@media (max-width: 700px)': {
    gridTemplateColumns: '1fr',
  },
});

export const SettingGroup = styled(Box)({
  '& label': {
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: '6px',
    marginRight: '14px',
  },
});
